import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DomainService } from '../../services/domain.service';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../services/notification.service';
import { EnvironmentService } from '../../services/environment.service';

@Component({
    selector: 'itpx-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: [ './welcome.component.css' ]
})
export class WelcomeComponent implements OnInit {

    private domain: any;
    private images: string;

    constructor(
        private router: Router,
        private domainService: DomainService,
        private authService: AuthService,
        private notificationService: NotificationService,
        private environmentService: EnvironmentService
    ) { 
    }


    ngOnInit() {
        this.domain = this.domainService.getDomain();
        this.images = this.environmentService.config['server'].images;
    }

    // basicAuth() {
    //     this.authService.basicAuth(this.model)
    //         .subscribe(
    //             data => this.handleData(data),
    //             error => this.handleError(error)
    //         )
    // }

    // handleData(data: any) {
    //     let userDetails = data.userDetails;
    //     this.notificationService.success(userDetails.username, 'Welcome,')
    //     this.router.navigate(['app']);
    // }

    // handleError(error: any) {
    //     this.notificationService.error(error, 'Error')
    // }

    login() {
        this.authService.login();
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/welcome/welcome.component.ts